import { render, staticRenderFns } from "./standart-table.vue?vue&type=template&id=c3576ba0&scoped=true&"
import script from "./standart-table.vue?vue&type=script&lang=ts&"
export * from "./standart-table.vue?vue&type=script&lang=ts&"
import style0 from "./standart-table.vue?vue&type=style&index=0&id=c3576ba0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3576ba0",
  null
  
)

export default component.exports